import { Fragment } from 'react';
import { useParams } from 'react-router-dom';

import { Spinner } from '@components/loading-spinner';
import { TooltipStyles } from '@components/tooltip';
import { DatePickerStyles } from '@styles/datepicker';

import { useForm, useSaveForm } from 'api/form';

import { DisplayForm } from './display-form';
import { FormLoadError } from './form-load-error';
import { SubmissionSuccess } from './submission-success';

type RootRouteParams = {
  uuid: string;
};

export const ComboSendForm = () => {
  const { uuid } = useParams() as RootRouteParams;
  const formQuery = useForm(uuid);
  const saveMutation = useSaveForm(uuid);

  if (formQuery.isLoading || saveMutation.isLoading) {
    return <Spinner />;
  }

  if (!formQuery.data) {
    return <FormLoadError />;
  }

  const showSubmissionSuccessPage = saveMutation.data?.data.isComplete && saveMutation.isSuccess;

  return (
    <Fragment>
      <DatePickerStyles />
      <TooltipStyles />

      {showSubmissionSuccessPage ? (
        <SubmissionSuccess submissionMessageConfig={formQuery.data?.submissionMessageConfig} />
      ) : (
        <DisplayForm
          key={formQuery.dataUpdatedAt}
          formConfig={formQuery.data.fieldsConfig}
          formAnswers={formQuery.data.formAnswers ?? []}
          onSubmit={saveMutation.mutateAsync}
        />
      )}

      {formQuery.isError && <FormLoadError />}
    </Fragment>
  );
};
